<div class="report-filter-bar">
  <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
    <div class="btn-group preset-group" role="group">
      <button *ngFor="let preset of presets" type="button" class="btn btn-sm"
        [class.btn-primary]="selectedPeriod === preset"
        [class.btn-outline-primary]="selectedPeriod !== preset"
        [disabled]="disabled" (click)="selectPeriod(preset)">
        {{ presetKey(preset) | translate }}
      </button>
    </div>
    <div class="export-actions ms-auto d-flex align-items-center flex-wrap gap-2" *ngIf="showExportButton">
      <div class="btn-group btn-group-sm" role="group" *ngIf="showExportDetailLevel">
        <button type="button" class="btn"
          [class.btn-secondary]="exportDetailLevel === 'summary'"
          [class.btn-outline-secondary]="exportDetailLevel !== 'summary'"
          [disabled]="disabled" (click)="setExportDetailLevel('summary')">
          {{ 'KPI.FILTER_BAR.EXPORT_DETAIL_SUMMARY' | translate }}
        </button>
        <button type="button" class="btn"
          [class.btn-secondary]="exportDetailLevel === 'detailed'"
          [class.btn-outline-secondary]="exportDetailLevel !== 'detailed'"
          [disabled]="disabled" (click)="setExportDetailLevel('detailed')">
          {{ 'KPI.FILTER_BAR.EXPORT_DETAIL_DETAILED' | translate }}
        </button>
      </div>
      <span class="text-muted small">{{ 'KPI.FILTER_BAR.EXPORT' | translate }}:</span>
      <button *ngFor="let fmt of exportFormats" type="button" class="btn btn-sm btn-outline-success"
        [disabled]="disabled" (click)="onExport(fmt)">
        <nb-icon icon="download-outline"></nb-icon> {{ fmt | uppercase }}
      </button>
    </div>
  </div>
  <div class="custom-range row align-items-end g-2" *ngIf="selectedPeriod === 'custom'">
    <div class="col-auto">
      <label class="form-label small mb-1">{{ 'KPI.FILTER_BAR.START_DATE' | translate }}</label>
      <input nbInput type="date" class="form-control form-control-sm" [(ngModel)]="customStartDate" />
    </div>
    <div class="col-auto">
      <label class="form-label small mb-1">{{ 'KPI.FILTER_BAR.END_DATE' | translate }}</label>
      <input nbInput type="date" class="form-control form-control-sm" [(ngModel)]="customEndDate" />
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary btn-sm" [disabled]="disabled || applyingCustom" (click)="applyCustomRange()">
        {{ 'KPI.FILTER_BAR.APPLY' | translate }}
      </button>
    </div>
  </div>
  <div class="store-filter mt-2" *ngIf="showStoreFilter && stores.length > 0">
    <div class="d-flex align-items-center gap-2 mb-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="disabled" (click)="showStorePicker = !showStorePicker">
        <nb-icon icon="home-outline"></nb-icon>
        {{ 'KPI.FILTER_BAR.SELECT_STORES' | translate }} ({{ selectedStoreIds.size }}/{{ stores.length }})
      </button>
      <button type="button" class="btn btn-sm btn-link" [disabled]="disabled" (click)="selectAllStores()">{{ 'KPI.FILTER_BAR.SELECT_ALL' | translate }}</button>
      <button type="button" class="btn btn-sm btn-link" [disabled]="disabled" (click)="clearStoreSelection()">{{ 'KPI.FILTER_BAR.CLEAR_ALL' | translate }}</button>
    </div>
    <div class="store-chips d-flex flex-wrap gap-2" *ngIf="showStorePicker">
      <label *ngFor="let store of stores" class="store-chip" [class.selected]="isStoreSelected(store._id)">
        <input type="checkbox" [checked]="isStoreSelected(store._id)" [disabled]="disabled" (change)="toggleStore(store._id)" /> {{ store.name }}
      </label>
    </div>
  </div>
</div>
